import React from 'react';
import NewBadge from 'src/components/NewBadge/NewBadge';
import calcomLogo from 'src/pages/Calendar/CalcomIntegration/calcom-logo.svg';
import './calcom-connection-badge.scss';

interface CalcomConnectionBadgeProps {
  isConnected: boolean;
}

const CalcomConnectionBadge = ({ isConnected }: CalcomConnectionBadgeProps) => {
  const dotModifier: string = isConnected
    ? 'calcom-connection-badge-dot--connected'
    : 'calcom-connection-badge-dot--disconnected';

  return (
    <span className="calcom-connection-badge">
      <span className={`calcom-connection-badge-dot ${dotModifier}`} />
      <img
        src={calcomLogo}
        className="calcom-connection-badge-logo"
        alt="Cal.com"
      />
      <span className="calcom-connection-badge-status">
        {isConnected ? 'connected' : 'not connected'}
      </span>
      <NewBadge spaced beta />
    </span>
  );
};

export default CalcomConnectionBadge;